<template>
  <header
    class="header"
    ref="header"
    :class="{'header--scrolled' : reachedGap}"
  >
    <div class="header__top" >
      <div class="container-fluid">
        <div class="flex-container">
          <div class="header__top__left-box">
            <MenuToggleButton
              class="categories-navbar-toggle-button"
            />

            <router-link :to="{ name: 'home' }" class="logo-box">
              <div class="logo-box__logo">
                <img src="@/assets/img/cyberclass-20.svg" alt="CyberClass" class="d-none d-md-inline-block logo-box__logo__img" />
                <img height="35" src="@/assets/img/logo-icone-20.svg" class="d-inline-block d-md-none" alt="CyberClass" />
              </div>
            </router-link>

            <MainMenuNavbar
              v-if="!isLogged || $store.getters['user/user'].is_personal_infos_filled"
            />
          </div>

          <div class="auth-box">
            <div
              v-if="!isLogged || $store.getters['user/user'].is_personal_infos_filled"
              class="menu-options"
            >
              <SearchToggleButton />

              <TimelineToggleButton v-if="isLogged" />

              <NotificationButton :user="user" v-if="isLogged" />
            </div>

            <IconButton
              v-if="!isLogged"
              image="signin.svg"
              alt="Icone entrar"
              @clicked="openAuthModal"
            >
              <span class="d-none d-sm-block text-primary ml-3">Entrar</span>
            </IconButton>

            <UserAvatarDropdown
              v-if="isLogged"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="header__slot">
      <slot v-bind:calculate-padding-gap="calculatePaddingGap" />
    </div>

    <div class="header__slot__fixed">
      <slot name="fixed" />
    </div> -->
  </header>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import IconButton from '@/components/buttons/IconButton'
  import AuthFormModal from '@/components/modals/auth/AuthFormModal'
  import UserAvatarDropdown from '@/components/user/template/UserAvatarDropdown'
  import TimelineToggleButton from '@/components/timeline/TimelineToggleButton'
  import MenuToggleButton from '@/components/layout/menu/MenuToggleButton'
  import SearchToggleButton from '@/components/search/SearchToggleButton'
  import MainMenuNavbar from '@/components/layout/menu/MainMenuNavbar'
  import NotificationButton from '@/components/notification/NotificationButton'

  export default {
    components: {
      IconButton,
      UserAvatarDropdown,
      TimelineToggleButton,
      SearchToggleButton,
      MenuToggleButton,
      MainMenuNavbar,
      NotificationButton
    },

    data: () => ({
      gap: 0,
      pageYOffset: 0
    }),

    mounted () {
      // this.gap = this.calculatePaddingGap()
      // this.pageYOffset = window.pageYOffset

      // window.onresize = () => { this.gap = this.calculatePaddingGap() }
      // window.onscroll = () => this.pageYOffset = window.pageYOffset

      const routeMatch = [
        { path: '#/criar-conta', action: 'sign-up' },
        { path: '#/recuperar-senha', action: 'sign-in' },
        { path: '#/entrar', action: 'sign-in' }
      ].find(route => window.location.hash.includes(route.path))
  
      if (!this.isLogged && routeMatch) {
        this.openAuthModal(routeMatch.action)
      }
    },
    // beforeDestroy () {
    //   document.body.style.paddingTop = '0';
    // },

    computed: {
      ...mapGetters('user', ['isLogged', 'user']),

      reachedGap () {
        return this.pageYOffset >= this.gap
      }
    },

    // watch: {
    //   isStudyingTheme () {
    //     this.$nextTick(() => this.calculatePaddingGap())
    //   }
    // },

    methods: {
      ...mapActions('slideSidebar', [
        'slideSidebarToggle',
      ]),

      openAuthModal (defaultTab) {
        this.$modal.show(AuthFormModal, { defaultTab }, { width: '343px' }, {
          'closed': () => this.$store.commit('auth/resetModal')
        })
      },

      // calculatePaddingGap () {
      //   const gap = this.$refs.header ? this.$refs.header.offsetHeight : 0

      //   if (!gap) {
      //     console.log('gap header', this.$refs.header)
      //   }

      //   document.body.style.paddingTop = gap + 'px'

      //   return gap
      // }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .header {
    $p: &;

    z-index: 100;
    // position: absolute;
    // top: 0;
    // left: 0;
    // width: 100%;
    // transform: translateY(-100%);
    // margin-top: 5rem;
    padding: 0 15px;
    border-bottom: 1px solid #FFFFFF1A;

    // &:not(&--scrolled) {
    //   // box-shadow: 0px 15px 60px rgba(#000, .035);
    //   border-bottom: 1px solid lighten(#000, 92);
    // }

    // &--scrolled {
    //   top: 10px;
    //   transition: 0.5s transform;
    //   position: fixed;
    //   margin-top: -5px;
    //   transform: translateY(5px);
  
    //   #{$p}__top {
    //     // max-width: 1100px;
    //     box-shadow: 0px 15px 45px rgba(#000, .065);
    //   }
    // }

    &__slot {
      position: relative;
      z-index: 2;

      @media(max-width: 769px) { display: none }
    }

    &__slot__fixed {
      position: relative;
      z-index: 1;
    }

    &__menu {
      margin-left: 40px;

      @media (max-width: 767px) {
        display: none!important;
      }
    }

    &__top {
      position: relative;
      z-index: 3;
      margin: auto;

      &__left-box {
        display: flex;
        align-items: center;

        @media (min-width: 769px) {
          .categories-navbar-toggle-button { display: none }
        }
      }

      .auth-box {
        display: flex;
        align-items: center;
      }

      .menu-options {
        margin-right: 15px;
        padding-right: 15px;
        border-right: 1px solid rgba(#000, .15);
        display: flex;

        & > *:not(:last-child) { margin-right: 10px }

        &__button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          background: rgba(#000, .075);
          border-radius: 100%;

          ::v-deep svg { 
            width: 20px; 
            height: 20px; 
            fill: #DEE3F0; 
          }

          &--active {
            background-color: $purple85;
            // color: #fff;

            ::v-deep svg { 
              fill: $white100; 
            }
          }
        }
      }

      .logo-box {
        position: relative;
        display: flex;
        align-items: center;

        &__logo {
          &__img {
            height: 30px;
          }

          &__beta-tag {
            font-weight: 700;
            font-size: 11px;
            padding: 1px 5px;
            border-radius: 5px;
            background: #ff8000;
            text-transform: uppercase;
            color: #fff;
            position: absolute;
            top: calc(100% - 5px);
            right: 0;

            @media (max-width: 767px) {
              top: -15px;
              left: 26px;
              right:auto;
              font-size: 10px;
            }
          }
        }

        &__text {
          font-size: 0;
          transform: translateY(-1000px);
          transition: .5s all;
        }
      }

      .flex-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 87px;

        @media (max-width: 767px) {
          height: 68px;
        }
      }
    }
  }
</style>